import { makeStyles } from 'tss-react/mui';
export default makeStyles()(function (theme) {
  return {
    root: {
      flex: 1
    },
    notUnderline: {
      '&::before': {
        borderBottom: 0
      }
    },
    select: {
      '& .MuiSelect-icon': {
        color: theme.palette.active ? theme.palette.active.main : 'inherit',
        marginTop: '2px'
      },
      '& .MuiOutlinedInput-input': {
        paddingTop: '14px',
        paddingBottom: '18px'
      }
    },
    itemImage: {
      maxHeight: theme.spacing(3),
      maxWidth: theme.spacing(3),
      marginRight: theme.spacing(1)
    },
    roundImages: {
      borderRadius: theme.spacing(1)
    },
    itemAvatar: {
      marginRight: theme.spacing(2)
    }
  };
});